<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import moment from 'moment'
import {
  courseListMethod,
  authComputed,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Add Event',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      title: '',
      start: '',
      end: '',
      starttime: '00:00:00',
      endtime: '23:59:00',
      eventError: null,
      eventDataStatus: false,
      isEventError: false,
      isLoading: false,
      show: false,
      timeError: false,
      timeError1: false,
      goneTimeError: false,
      classlist: [],
      collegeId: '',
      collegeClass: [],
      departmentId: [],
      departmentlist: [],
      type: null,
      eventList: [
        { value: null, text: 'Select Event Type', disabled: true },
        { value: 'event', text: 'event' },
        { value: 'holiday', text: 'holiday' },
        { value: 'exam', text: 'exam' },
      ],
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getClasses()
    this.collegeId = this.profileData.college_id
    if (this.role === 'college') {
      this.getDepartments()
    } else if (this.role === 'teacher') {
      this.collegeClass = this.profileData.collegeClass
      this.departmentId.push(this.profileData.department)
    } else if (this.role === 'hod') {
      this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
  },
  methods: {
    ...courseListMethod,
    ...userListMethod,
    ...departmentListMethod,

    addEventData() {
      let eventData = {}
      eventData.title = this.title
      eventData.collegeClass = this.collegeClass
      eventData.college_id = this.collegeId
      eventData.department = this.departmentId
      eventData.type = this.type
      if (
        this.starttime !== '' &&
        this.endtime !== '' &&
        this.starttime > this.endtime &&
        this.end !== '' &&
        this.start !== ''
      ) {
        this.timeError1 = true
      } else {
        this.timeError1 = false
      }
      if (this.start !== '') {
        let datetime = moment(
          `${this.start} ${this.starttime}`,
          'YYYY-MM-DD HH:mm:ss'
        ).format()
        const now = new Date()
        const today = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          now.getHours(),
          now.getMinutes(),
          now.getSeconds()
        )
        const minDate = new Date(today)
        const d1 = new Date(moment(minDate).format())
        const d2 = new Date(datetime)
        if (d1 > d2) {
          this.goneTimeError = true
        } else {
          this.goneTimeError = false
        }
        eventData.start = datetime
      }
      if (this.end !== '') {
        let datetime = moment(
          `${this.end} ${this.endtime}`,
          'YYYY-MM-DD HH:mm:ss'
        ).format()
        eventData.end = datetime
      }
      if (!this.timeError && !this.timeError1 && !this.goneTimeError) {
        this.isLoading = true
        this.addCalendarEvent({ eventData })
          .then((data) => {
            this.isLoading = false
            this.$bvToast.toast('Success', {
              title: appConfig.event_success_message,
              toaster: 'b-toaster-top-right',
              solid: true,
              variant: 'success',
              autoHideDelay: 5000,
            })
            this.$router.push({ name: 'calendar' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.eventError = getError.message
            this.isEventError = true
            window.scrollTo(0, 0)
          })
      }
    },

    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate())
      return minDate
    },

    getMinDate1() {
      const now = new Date(this.start)
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate())
      return minDate
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    getDepartments() {
      this.departmentId.push(null)
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Department',
            disabled: true,
          })
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },

    getClasses() {
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            var i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card class="scroll">
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isEventError"
              variant="danger"
              v-html="eventError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="addEventData"
            >
              <b-form-group label="Title*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="title"
                  type="text"
                  parsley-trigger="change"
                  placeholder="Enter Title"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Select Event Type*" label-for="input-1">
                <b-form-select
                  v-model="type"
                  :options="eventList"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Start Date*" label-for="input-2">
                <b-form-datepicker
                  id="example-datepicker1"
                  v-model="start"
                  :min="getMinDate()"
                ></b-form-datepicker>
              </b-form-group>
              <b-form-group label="End Date*" label-for="input-3">
                <b-form-datepicker
                  id="example-datepicker2"
                  v-model="end"
                  :min="getMinDate1()"
                ></b-form-datepicker>
              </b-form-group>
              <label for="example-input">Start Time</label>
              <b-form-input
                id="example-time-input"
                v-model="starttime"
                class="form-control"
                type="time"
              >
              </b-form-input>
              <br />

              <label for="example-input1">End Time</label>
              <b-form-input
                id="example-time-input1"
                v-model="endtime"
                class="form-control"
                type="time"
              >
              </b-form-input>
              <br />
              <b-form-group
                v-if="role !== 'hod' && role !== 'teacher'"
                label="Select Department*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="departmentId"
                  :options="departmentlist"
                  multiple
                  @change="getClasses"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="role !== 'teacher'"
                label="Select Class*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeClass"
                  :options="classlist"
                  multiple
                ></b-form-select>
              </b-form-group>
              <br />
              <p v-if="timeError1" style="color: red"
                >Please add end time greater than start time</p
              >
              <p v-if="timeError" style="color: red"
                >Please add valid start/end time</p
              >
              <p v-if="goneTimeError" style="color: red"
                >Added past date/time</p
              >
              <p class="note"
                >Note: If time is not selected then by default event will start
                at 12 AM and will end at 11:59 PM.</p
              >
              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/calendar"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.showError {
  color: red;
}
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
.scroll {
  overflow-y: auto;
}
.btn .b-icon.bi,
.dropdown-item .b-icon.bi,
.dropdown-toggle .b-icon.bi,
.input-group-text .b-icon.bi,
.nav-link .b-icon.bi {
  color: gray !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: white !important;
  border-color: #ced4da !important;
}

.note {
  font-size: 16px;
  color: black;
  background-color: yellow;
}
</style>
